const CUTOUT_SPRAY_CYAN = "#71e0ff";
const CUTOUT_SPRAY_BAND_RADIUS = 10;
const CUTOUT_SPRAY_BLUR = 15;
const CUTOUT_SPRAY_BASE_FREQUENCY = 0.55;

/** CSS-filter params were tuned against ~this preview height; bake scales from it. */
export const CUTOUT_SPRAY_PREVIEW_REF_HEIGHT = 300;

export function cutoutSprayFilterDefs(
  ids: { band: string; spray: string },
  canvasHeight: number,
): string {
  const scale = canvasHeight / CUTOUT_SPRAY_PREVIEW_REF_HEIGHT;
  const { band, spray } = ids;
  const r = CUTOUT_SPRAY_BAND_RADIUS * scale;
  const blur = CUTOUT_SPRAY_BLUR * scale;
  const frequency = CUTOUT_SPRAY_BASE_FREQUENCY / scale;
  // Extra filter region so scaled dilation/blur is not clipped at bake size.
  return `
    <filter id="${band}" x="-80%" y="-80%" width="260%" height="260%" color-interpolation-filters="sRGB">
      <feMorphology in="SourceAlpha" operator="dilate" radius="${r}" result="fat"/>
      <feFlood flood-color="${CUTOUT_SPRAY_CYAN}" result="paint"/>
      <feComposite in="paint" in2="fat" operator="in"/>
    </filter>
    <filter id="${spray}" x="-80%" y="-80%" width="260%" height="260%" color-interpolation-filters="sRGB">
      <feMorphology in="SourceAlpha" operator="dilate" radius="${r}" result="fat"/>
      <feGaussianBlur in="fat" stdDeviation="${blur}" result="soft"/>
      <feTurbulence type="fractalNoise" baseFrequency="${frequency}" numOctaves="4" seed="7" stitchTiles="noStitch" result="noise"/>
      <feComposite in="soft" in2="noise" operator="arithmetic" k1="2" k2="0.1" k3="0" k4="0.24" result="mix"/>
      <feComponentTransfer in="mix" result="cut">
        <feFuncA type="discrete" tableValues="0 0 1 1"/>
      </feComponentTransfer>
      <feFlood flood-color="${CUTOUT_SPRAY_CYAN}" result="paint"/>
      <feComposite in="paint" in2="cut" operator="in"/>
    </filter>
  `;
}
